import { render } from "./BuyNowCompletedPurchasesPage.vue?vue&type=template&id=7a7c7af2"
import script from "./BuyNowCompletedPurchasesPage.vue?vue&type=script&lang=js"
export * from "./BuyNowCompletedPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__